import { sharedEthnikiFields } from '@/views/checkouts/companies/Ethniki/shared/sharedEthnikiSchema';
import * as yup from 'yup';

export const BikeEthnikiSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  return yup.object({
    ...sharedEthnikiFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      secondDriverAdditionalPremiumLicenseYears,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
  });
};

export default BikeEthnikiSchemaBuilder;
